export default __webpack_public_path__ + "assets/img_other_object_xl-3d927879.png";